export function getLocalCalendarDate(value = new Date()) {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function syncUntouchedDateDefault(currentValue, previousDefault, nextDefault) {
  if (!nextDefault || nextDefault === previousDefault) return currentValue;
  return !currentValue || currentValue === previousDefault ? nextDefault : currentValue;
}
